import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { findNavigationItem } from '../../config/navigation';

function Breadcrumbs() {
  const { pathname } = useLocation();
  const currentItem = findNavigationItem(pathname);

  return (
    <nav className="flex items-center gap-1.5 text-sm" aria-label="Migas de pan">
      <Link to="/dashboard" className="text-content-muted transition hover:text-content-primary" aria-label="Inicio">
        <Home className="size-4" />
      </Link>
      {currentItem && (
        <>
          <ChevronRight className="size-3.5 text-slate-400" aria-hidden="true" />
          <span className="font-medium text-content-secondary" aria-current="page">{currentItem.name}</span>
        </>
      )}
    </nav>
  );
}

export default Breadcrumbs;
